import { useEffect } from 'react';

import { flushDueCancellations } from '../lib/cancellation-sync';

const TICK_MS = 20_000;

/**
 * Sends cancellation reports that were saved with no signal: once on app start, on every
 * `online` event, and on a slow tick (backoff is per record, so a tick with nothing due makes
 * no request). Mounted once, in the dashboard layout.
 */
export const useCancellationAutoFlush = (enabled: boolean) => {
	useEffect(() => {
		if (!enabled) return;
		const flush = () => void flushDueCancellations();
		flush();
		window.addEventListener('online', flush);
		const timer = window.setInterval(() => {
			if (typeof navigator === 'undefined' || navigator.onLine) flush();
		}, TICK_MS);
		return () => {
			window.removeEventListener('online', flush);
			window.clearInterval(timer);
		};
	}, [enabled]);
};
